import { useAuthenticator } from '@aws-amplify/ui-react';
import HGSpinner from 'components/HGSpinner';
import { useEffect } from 'react';

export const Logout = () => {
    const { user, signOut } = useAuthenticator((context) => [context.user]);

    useEffect(() => {
        signOut();
        sessionStorage.clear();
    }, []);

    return (
        <div>
            <HGSpinner size={50} />
        </div>
    );
};
